import {Components} from '@mui/material';

import {Colors} from '@constants/colors.constants';

const buttons: Components = {
  MuiButton: {
    defaultProps: {disableElevation: true},
    styleOverrides: {
      contained: (props) => ({
        borderRadius: 4,
        display: 'flex',
        fontSize: 14,
        fontWeight: 700,
        height: 38,
        padding: '10px 20px',
        textTransform: 'none',
        '& > .MuiButton-startIcon': {
          marginRight: 10,
        },
        '&.Mui-disabled': {
          opacity: 0.5,
          backgroundColor: props.ownerState.color === 'primary' ? Colors.primary : undefined,
          color: props.ownerState.color === 'primary' ? Colors.white : undefined,
        },
      }),
      containedSizeSmall: {
        height: 30,
        fontWeight: 400,
        padding: '6px 10px',
        '& > .MuiButton-startIcon': {
          marginRight: 6.5,
        },
      },
      outlined: {
        borderRadius: 4,
        fontSize: 14,
        fontWeight: 700,
        height: 38,
        padding: '10px 20px',
        textTransform: 'none',
        '&.Mui-disabled': {
          '& svg': {
            opacity: 0.3,
          },
        },
        '& > .MuiButton-startIcon': {
          marginRight: 10,
        },
      },
      outlinedSizeSmall: {
        height: 30,
        fontWeight: 400,
        padding: '6px 10px',
        '& > .MuiButton-startIcon': {
          marginRight: 6.5,
        },
      },
      outlinedPrimary: {
        color: Colors.text,
      },
      startIcon: {
        marginRight: 10,
      },
      textPrimary: {
        textTransform: 'none',
        '& > .MuiButton-endIcon': {
          marginLeft: 6,
        },
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: (props) => ({
        ...(props.ownerState['aria-label'] === 'small-square-text' ? {
          backgroundColor: Colors.text,
          borderRadius: 4,
          height: 24,
          width: 24,
          '&:hover': {
            backgroundColor: Colors.text,
          },
        } : {}),
        ...(props.ownerState['aria-label'] === 'medium-square-primary' ? {
          backgroundColor: Colors.primary,
          borderRadius: 4,
          height: 38,
          width: 38,
          '&:hover': {
            backgroundColor: Colors.primary,
          },
        } : {}),
        ...(props.ownerState['aria-label'] === 'quantity' ? {
          backgroundColor: Colors.white,
          borderRadius: 4,
          height: 40,
          width: 34,
          '&.Mui-disabled': {
            backgroundColor: Colors.white,
            opacity: 0.5,
          },
          '&:hover': {
            backgroundColor: Colors.white,
          },
        } : {}),
        ...(props.ownerState['aria-label'] === 'remove-document' ? {
          backgroundColor: Colors.error,
          padding: 5,
          '&:hover': {
            backgroundColor: Colors.error,
          },
        } : {}),
      }),
    }
  },
};

export default buttons;
